import { Host, h } from "@stencil/core";
import state from "../store";
import { formMessageLogic } from "../../common/form";
import { formClasses } from "../../common/classesNames";
import { commonClassesNames } from "../../common/classesNames";
export class GxgSuggest {
    constructor() {
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.disabled = false;
        this.ellipsis = true;
    }
    render() {
        return (h(Host, { class: {
                large: state.large,
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled,
            } }, h("slot", null), formMessageLogic(this)));
    }
    static get is() { return "gxg-suggest"; }
    static get originalStyleUrls() {
        return {
            "$": ["styles.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["styles.css"]
        };
    }
    static get properties() {
        return {
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The message to display for the validation result."
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the suggest disabled."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "ellipsis": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute forces the suggest list items to not wrap to a second line, and it will display ellipsis. (...)"
                },
                "attribute": "ellipsis",
                "reflect": true,
                "defaultValue": "true"
            }
        };
    }
}
//# sourceMappingURL=suggest.js.map
